import React from 'react'
import { SvgIconProps } from './Home'

const SvgCheckOutIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="57"
    height="34"
    fill="none"
    viewBox="0 0 57 34"
  >
    <path
      fill={fill ?? "#353535"}
      d="M1.4 32.2c3.2.7 6.6 1 10.1 1s6.9-.4 10.1-1c.8-.2 1.4-1 1.3-1.8l-.8-6.5c-.5-4-3.9-7-7.9-7H8.7c-4 0-7.4 3-7.9 7L0 30.4c0 .8.6 1.6 1.4 1.8zM11.5 15a7.5 7.5 0 100-15 7.5 7.5 0 000 15zM36.5 14.3v4.8c0 .5.4 1 1 1h7.9V24a1 1 0 001.6.8l9.3-7.2c.5-.4.5-1.2 0-1.6L47 8.8c-.6-.5-1.6 0-1.6.8v3.9h-7.8c-.6-.2-1.1.2-1.1.8z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M28.4 29.1h9.2c.4 0 .7-.3.7-.7v-3.8c0-.4-.3-.7-.7-.7h-4.5c-.1 0-.2-.1-.2-.2V9.5c0-.1.1-.2.2-.2h4.5c.4 0 .7-.3.7-.7V4.8c0-.4-.3-.7-.7-.7h-9.2c-.4 0-.7.3-.7.7v23.6c0 .4.3.7.7.7z"
    ></path>
  </svg>
)


export default SvgCheckOutIcon